import { useContext } from 'react';

import {
  SearchTermStateContext,
  SearchTermDispatchContext,
} from 'search/providers/SearchTermProvider';

export const useSearchTermState = () => useContext(SearchTermStateContext);
export const useSearchTermDispatch = () => useContext(SearchTermDispatchContext);
